import { render, staticRenderFns } from "./NeighborhoodFormDialog.vue?vue&type=template&id=7f8ed4e1&"
import script from "./NeighborhoodFormDialog.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports